export const wordDate = (dateString: string) => {
  const date = new Date(dateString);
  const options: any = { year: "numeric", month: "short", day: "2-digit" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  //   console.log(formattedDate);
  return formattedDate;
};

// Convert MongoDB date and time
export const dateAndTime = (str: string) => {
  const date = new Date(str);

  // Options for a more readable format
  const options: any = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short",
  };

  const humanReadableDate = date.toLocaleDateString("en-Us", options);
  return humanReadableDate;
};
